<form class="card d-flex direction-column align-center" [formGroup]="lotsForm">
  <div class="card-content content d-flex align-center justify-space-between column-gap-10">
    <ng-content select="[cardFlag]"></ng-content>

    <div class="content-checkbox flex-1" *ngIf="mode === Mode.Transfer">
      <app-svg-icon *ngIf="lote.IsInvoiced || lote.HasRpa"
                    width="18px"
                    height="18px"
                    color="success"
                    src="assets/icons/check-icon.svg">
      </app-svg-icon>
    </div>

    <div class="content-checkbox flex-2">
      <app-svg-icon src="../../../../assets/icons/status-repasse.svg"
                    width="20px"
                    height="20px"
                    [ativo]="lote.Active!"
                    color="">
      </app-svg-icon>
    </div>

    <div class="data-group group flex-4">
      <span class="field-label">Lote</span>
      <span class="group-data data">
        <strong class="data-emphasis"> </strong>{{ lote.BatchNumber || "-" }}
      </span>
    </div>

    <ng-container *ngIf="mode === Mode.Transfer; else invoicingLotFields">
      <div class="data-group group d-flex direction-column flex-4">
        <span class="field-label">Banco</span>
        <span class="group-data data d-flex justify-center align-center">
          {{ (lote.Bank | titlecase) || "-" }}
          <span
            *ngIf="lote.Type === 'Manual' && lote.Bank && lote.IsMultipleBanks"
            class="ml-5 plus-icon">+</span>
        </span>
      </div>

      <div class="data-group group d-flex direction-column flex-4">
        <span class="field-label">Parceiro</span>
        <div class="d-flex align-center">
          <div class="flex-8">
            <span class="group-data data">
              {{ (lote.Partner | titlecase) || "-" }}
            </span>
          </div>
          <span
            *ngIf="lote.Type === 'Manual' && lote.Partner && lote.IsMultiplePartners"
            class="group-data data flex-1 plus-icon">+</span>
        </div>
      </div>

      <div class="data-group group flex-4">
        <span class="field-label">Status do Pagamento</span>
        <span class="group-data data">{{ (!!lote.PaymentDate && "Pago") || lote.SapPaymentStatus || "Pendente" }}</span>
      </div>

      <div class="data-group group flex-4">
        <span class="field-label">Data do Lote</span>
        <span class="group-data data">
          {{ lote.CreateDate ? (lote.CreateDate | systemDate : "dd/MM/yyyy") : "-" }}
        </span>
      </div>

      <div class="data-group group flex-4">
        <span class="field-label">Data de envio e-mail</span>
        <span class="group-data data">
          {{ lote.EmailTransferDate ? (lote.EmailTransferDate | systemDate : "dd/MM/yyyy") : "-" }}
        </span>
      </div>

      <div class="data-group group flex-4">
        <span class="field-label">Data e-mail pgto</span>
        <span class="group-data data">
          {{ lote.EmailEstimatedPaymentDate ? (lote.EmailEstimatedPaymentDate | date : "dd/MM/yyyy") : "-" }}
        </span>
      </div>

      <div class="data-group group flex-4">
        <span class="field-label">Valor do Repasse</span>
        <span class="group-data data">
          {{ (lote.AmountTotal | currency : "BRL") || "-" }}
        </span>
      </div>

      <div class="data-group group flex-4" *ngIf="tabType === 'solicitado' || tabType === null || tabType === undefined">
        <span class="field-label">Qt. de Contratos</span>
        <span class="group-data data">{{ lote.NumberOfContracts || "-" }}</span>
      </div>
    </ng-container>

    <ng-template #invoicingLotFields>
      <div *ngIf="mode === Mode.Invoicing" class="data-group group flex-3">
        <span class="group-data data">
          {{ lote.OperationType }}
        </span>
      </div>

      <div *ngIf="mode === Mode.Invoicing" class="data-group group flex-3">
        <span class="group-data data">
          {{ lote.Bpo }}
        </span>
      </div>

      <div *ngIf="mode === Mode.Invoicing" class="data-group group flex-4">
        <span class="group-data data">
          {{ lote.CreateDate ? (lote.CreateDate | systemDate : "dd/MM/yyyy") : "-" }}
        </span>
      </div>

      <div *ngIf="mode === Mode.Invoicing" class="data-group group flex-4">
        <span class="group-data data">
          {{ (lote.PaymentDate | date : "dd/MM/yyyy") || "-" }}
        </span>
      </div>

      <div *ngIf="mode === Mode.Invoicing" class="data-group group flex-4">
        <span class="group-data data">
          {{ (lote.EmailInvoiceDate | systemDate : "dd/MM/yyyy") || "-" }}
        </span>
      </div>

      <div *ngIf="mode === Mode.Invoicing" class="data-group group flex-4">
        <span class="group-data data">{{ lote.Bank || "-" }}</span>
      </div>

      <div *ngIf="mode === Mode.Invoicing" class="data-group group flex-4">
        <span class="group-data data">
          {{ (lote.AmountTotal | currency : "BRL") || "-" }}
        </span>
      </div>

      <div *ngIf="mode === Mode.Invoicing" class="data-group group flex-4">
        <span class="group-data data">{{ lote.NumberOfContracts || "-" }}</span>
      </div>
    </ng-template>

    <div class="data-group group flex-4 status-column">
      <span class="field-label">{{ mode === Mode.Transfer ? 'Status do Lote' : 'Status Faturamento' }}</span>
      <span class="group-data-status status" [ngClass]="{ warn: lote.IntegrationError }">
        {{ (lote.IntegrationError && "Erro") || lote.BatchStatus || lote.StatusOfOnlending}}
      </span>
      <div class="sap-error" *ngIf="lote.IntegrationError" [matTooltip]="lote.IntegrationMsg!">!</div>
    </div>

    <div class="content-btn d-flex flex-1">
      <button type="button"
              class="card-btn d-flex align-center justify-center"
              (click)="routeToDetails(lote.BatchId.toString(), lote.Type || 'Automatic')">
        <app-svg-icon src="assets/icons/edit-icon.svg"
                      width="12px"
                      color="white"></app-svg-icon>
      </button>
    </div>
  </div>
</form>
